<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-1">
      {{ $t("mp:application.overview.title") }}
    </p>
    <p class="mb-5">
      {{ $t("mp:application.overview.subtitle") }}
    </p>

    <section v-if="!loaded">
      <article class="media" v-for="ll in 3" :key="ll">
        <figure class="media-left">
          <p class="image is-64x64">
            <b-skeleton circle width="64px" height="64px"></b-skeleton>
          </p>
        </figure>
        <div class="media-content">
          <div class="content">
            <p>
              <b-skeleton active></b-skeleton>
              <b-skeleton height="80px"></b-skeleton>
            </p>
          </div>
          <nav class="level is-mobile">
            <div class="level-left">
              <a class="level-item">
                <span class="icon is-small">
                  <b-skeleton></b-skeleton>
                </span>
              </a>
              <a class="level-item">
                <span class="icon is-small">
                  <b-skeleton></b-skeleton>
                </span>
              </a>
            </div>
          </nav>
        </div>
      </article>
    </section>

    <section v-if="loaded">
      <div
        class="mp-tile is-flex is-align-items-center"
        v-for="field in fields"
        v-bind:key="field.identifier"
      >
        <p class="mb-1 overview-block">
          <span class="overview-question">{{ field.question }}</span>

          <span class="has-text-weight-medium overview-answer">{{
            field.answer
          }}</span>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { FLOW_POSITION } from "@/utils/const";
import { mapActions } from "vuex";
import flowOverviewMixin from "../../mixins/flowOverviewMixin";

export default {
  name: "ApplicationFlowContractCheck",
  components: {},
  mixins: [flowOverviewMixin],
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      FLOW_POSITION,
      loaded: false,
      fields: [],
    };
  },
  async mounted() {
    this.fields = await this.createFields();
    this.loaded = true;
  },
  methods: {
    ...mapActions({
      savePosition: "application/savePosition",
    }),
  },
};
</script>

<style scoped lang="scss">
.overview-block {
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  border-bottom: 1px #ecf0f6 solid;
  width: 100%;
}

.overview-question {
  color: #abbacd;
}

.overview-answer {
  text-align: right;
  float: right;
}
</style>
